import React, { useEffect, useState } from 'react';
import {
    Grid, Paper, Button
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchclothstklump, fetchclothstklump2 } from '../../../Store/PHPSlice/clothStock';
import { selectClothstklumplist } from '../../Selectors/UploadStock/ReadyMSelector';
import { useParams } from 'react-router-dom';

const ClothStkView = ({ data }) => {
    const issueLumps = data;
    const { Id } = useParams();
    const [lumpRows, setLumpRows] = useState([]);
    const [lumpTotMtr, setLumpTotMtr] = useState(0);
    const [balTotMtr, setBalTotMtr] = useState(0);
    const dispatch = useDispatch();
    const lumplist = useSelector(selectClothstklumplist);

    useEffect(() => {
        if (issueLumps === 1) {
            const split = Id?.split('-');
            if (split.length > 1) {
                const ids = {
                    bId: split[0],
                    infoId: split[1]
                };
                dispatch(fetchclothstklump2(ids));
            }
        } else {
            dispatch(fetchclothstklump(Id));
        }
    }, [Id, issueLumps]);

    useEffect(() => {
        if (issueLumps === 1) {
            if (lumplist?.data4?.length > 0) {
                setLumpRows(lumplist.data4);

                // EXACT DECIMAL TOTAL
                const totmtr = lumplist.data4.reduce((acc, lump) =>
                    acc + parseFloat(lump.mtr || 0), 0
                );


                setLumpTotMtr(totmtr);
            }
        } else {
            if (lumplist?.data?.length > 0) {
                setLumpRows(lumplist.data);

                // EXACT DECIMAL TOTAL
                const totmtr = lumplist.data.reduce((acc, lump) =>
                    acc + parseFloat(lump.mtr || 0), 0
                );

                const baltotmtr = lumplist.data.reduce((acc, lump) =>
                    acc + parseFloat(lump.bmtr || 0), 0
                );

                setLumpTotMtr(totmtr);
                setBalTotMtr(baltotmtr);
            }
        }
    }, [lumplist, issueLumps]);
    const handleBarcodePrint = (bId, infoId) => {
        // adjust route if needed
        window.open(`/ClothStkBarcodeView/${bId}/${infoId}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');

    };
    return (
        <>
            <div className="lump-content">
                <h3>Lump Details</h3>

                <table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Location</th>
                            <th>Rack</th>
                            <th>Barcode</th>
                            <th>Color</th>
                            <th>Lump Mtr/KG</th>
                            {issueLumps !== 1 && <th>Bal Mtr/KG</th>}
                            <th>Barcode Print</th>
                        </tr>
                    </thead>

                    <tbody>
                        {lumpRows.map((lumpRow, lumpIndex) => (
                            <tr key={lumpIndex}>
                                <td>{lumpIndex + 1}</td>

                                <td><input type="text" value={lumpRow.locNm} readOnly /></td>

                                <td><input type="text" value={lumpRow.rack} readOnly /></td>

                                <td><input type="text" value={lumpRow.barcode} readOnly /></td>

                                <td><input type="text" value={lumpRow.color} readOnly /></td>

                                <td><input type="text" value={lumpRow.mtr} readOnly /></td>

                                {issueLumps !== 1 && <td><input type="text" value={lumpRow.bmtr} readOnly /></td>}
                                <td>
                                    <Button
                                        variant="contained"
                                        size="small"
                                        color="secondary"
                                        onClick={() => handleBarcodePrint(lumpRow.bId, lumpRow.ID)}
                                    >
                                        Print
                                    </Button>
                                </td>
                            </tr>
                        ))}

                        <tr>

                            <td colSpan={5}>
                                <span className="tot-lump">Total</span>
                            </td>

                            <td>
                                <span className="tot-lump">{lumpTotMtr.toFixed(2)}</span>
                            </td>

                            {issueLumps !== 1 &&
                                <td>
                                    <span className="tot-lump">{balTotMtr.toFixed(2)}</span>
                                </td>
                            }
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default ClothStkView;
